import React from 'react'
import { render } from 'react-dom'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import { configureStore, history } from './app/init'
import { state as initialState } from './app/cache'
import App from './app/App'
import { configure } from './app/common/utils/helpers'
import { defaultAnonymousContext } from './helpers/ldHelpers'

// This code was taken from the unregister function in the registerServiceWorkers.js file in most react apps
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister()
  })
}

const store = configureStore(initialState)
configure(store)

;(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LD_CLIENT_ID,
    context: defaultAnonymousContext,
    timeout: 3,
  })

  render(
    <LDProvider>
      <App store={store} history={history} />
    </LDProvider>,
    document.getElementById('root'),
    () => {
      // Remove splash screen styles once the app has mounted
      document.body.classList.remove('splash-loading')
      const splashStyle = document.getElementById('splash-style')
      if (splashStyle) {
        splashStyle.remove()
      }
    }
  )
})()
